import { Tooltip, IconButton } from '@mui/material';
import { MdInfoOutline } from 'react-icons/md';
import { IInfoTooltip } from './InfoTooltip.types';

const InfoTooltip = (props: IInfoTooltip) => {
  return (
    <Tooltip title={props.message} placement='top'>
      <IconButton size='large'>
        <MdInfoOutline size={20} />
      </IconButton>
    </Tooltip>
  );
};
export default InfoTooltip;
